import { Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-resume-questionnaire',
    templateUrl: './resume-questionnaire.component.html',
    styleUrls: ['./resume-questionnaire.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false,
})
export class ResumeQuestionnaireComponent {
    @Output() ResumeQuestionnaire: EventEmitter<boolean> = new EventEmitter<boolean>();

    /* Function used to emit the event that the Resume button was clicked */
    public resumeQuestionnaire(status: boolean) {
        this.ResumeQuestionnaire.emit(status);
    }
}
